export const SHOW_PROGRESS='SHOW_PROGRESS';
export const PAGE_SIZE=10
export const MODAL_BITACORA='BITACORA'
export const MODAL_RDO='RDO'
export const MODAL_CONCEPTO='CONCEPTO'
export const MODAL_EJECUCION_SUP='EJECUCION_SUP'
export const INITIAL_CHARGE='INITIAL_CHARGE'
export const NAME_PROJECT='Talento FS'
export const ROLES_PERMITIDOS=[1,2,3]
export const ROLES_REG_UBICACION=[1,2,5]